import { getAPI, postAPI } from "../../api"
import { REACT_APP_CUSTOMERSETTINGS } from "../../utils/common"

export async function getupcomingCandidates(customerId: any) {
    const Details = getAPI( REACT_APP_CUSTOMERSETTINGS + `/upcoming-candidates/${customerId}`) 
    return Details
}

export async function getIncontractResources(customerId: any) {
    const Details = getAPI( REACT_APP_CUSTOMERSETTINGS + `/customer-contract-resources/${customerId}`) 
    return Details
}

export async function getAllResources(customerId: string | null | undefined, tab: string | undefined, pageNumber: number, pageSize: number, search?: string, body?: any) {
    const Details = postAPI( REACT_APP_CUSTOMERSETTINGS + `/upcoming-contract-candidates/${customerId}?tab=${tab}&page=${pageNumber}&size=${pageSize}&search=${search}`, body) 
     return Details
}

